import React, { useState } from "react";
import Popover from "@material-ui/core/Popover";
import styles from "./pop-over-list.module.scss";

const PopOverList = ({ children, list = [], className }) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (list.length > 0) {
      setAnchorEl(event.currentTarget);
      setOpen((previousOpen) => !previousOpen);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <span className={className}>
      <div onClick={handleClick}>{children}</div>
      <Popover
        id="pop-over-list"
        open={open}
        anchorEl={anchorEl}
        className={styles.popoverContainer}
        onClose={handleClose}
        keepMounted
      >
        {list.map((item, i) => {
          return (
            <div key={i} className={styles.content}>
              {item}
            </div>
          );
        })}
      </Popover>
    </span>
  );
};

export default PopOverList;
